var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column text-center pa-4"},[_c('m-chip-group',{staticClass:"mt-4",attrs:{"items":_vm.skills,"i18n-path":"onboarding_user.skills","multiple":""},model:{value:(_vm.interests),callback:function ($$v) {_vm.interests=$$v},expression:"interests"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }